<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">活动类型</li>
            </ol>
        </div>
        <div class="content-query content-border">
            <el-form :inline="true" :model="query" class="demo-form-inline">
                <el-form-item>
                    <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search"
                               @click="submitQuery(1)">刷新
                    </el-button>
                    <el-button type="primary" size="small" @click="$common.goRouterLink({ name: 'activityDetail' })">
                        添加
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <hr/>
        <div class="title">
            <span>活动类型列表</span>
        </div>
        <div class="content-data" v-if="0 < activitys.length">
            <el-table highlight-current-row :data="activitys" border>
                <el-table-column align="center" label="序号" type="index"/>
                <el-table-column align="center" label="主标题" prop="mainTitle"/>
                <el-table-column align="center" label="副标题" prop="subTitle"/>
                <el-table-column align="center" label="图片">
                    <template slot-scope="scope">
                        <el-image  :src="dynamicPath+scope.row.iconPath">
                            <div slot="error" class="image-slot">
                                <el-image title="加载失败"
                                          src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png"/>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="位置" prop="sequence" width="100px"/>
                <el-table-column align="center" fixed="right" label="操作" width="550px">
                    <template slot-scope="scope">
                        <el-button @click="saveSequence(scope.row.id,-1)" type="primary" size="mini">上移</el-button>
                        <el-button @click="saveSequence(scope.row.id,1)" type="primary" size="mini">下移</el-button>
                        <el-button @click="saveSequence(scope.row.id,-2)" type="primary" size="mini">置顶</el-button>
                        <el-button @click="saveSequence(scope.row.id,2)" type="primary" size="mini">置底</el-button>
                        <el-button @click="deleteActiveType(scope.row.id)" type="danger" size="mini">删除</el-button>
                        <el-button type="primary" size="mini"
                                   @click="$common.goRouterLink({ name: 'activityDetail', query: { activityId: scope.row.id }})">
                            修改
                        </el-button>
                        <el-button type="success" size="mini"
                                   @click="$common.goRouterLink({ name: 'activityGoodsList', query: { activityId: scope.row.id,title:scope.row.mainTitle }})">
                            查看活动商品
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager :datafile="fillData" url="/activity/pageActivity" :query="query" ref="pager"
                   :init="true"></vue-pager>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                query: {},
                activitys: [],
                dynamicPath:config.dynamicResourcePath
            }
        },
        methods: {
            fillData(_response) {
                this.activitys = _response.items || [];
            },
            submitQuery(_num) {
                this.$refs.pager.gotoPage(_num);
            },
            deleteActiveType: function (_activeId) {
                var _this = this;
                _this.$confirm('是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.$common.ajaxRequest({
                        url: '/activity/deleteActivity',
                        data: {
                            activityId: _activeId
                        },
                        success(response) {
                            _this.$message({
                                message: '删除成功',
                                type: 'success',
                                duration: 1000,
                                onClose: function () {
                                    _this.submitQuery();
                                }
                            });
                        }
                    })
                }).catch(() => {
                    console.log('delete cancel');
                });
            },

            saveSequence(_activeId, _direction) {
                let _this = this;
                _this.$common.ajaxRequest({
                    url: '/activity/saveSequence',
                    data: {
                        activityId: _activeId,
                        direction: _direction
                    },
                    success(response) {
                        _this.submitQuery(1);
                    }
                })
            },
        },
    }
</script>